const MAP_PAGE_SIZE = 100;

export async function fetchAllMapEntities(listEntities, baseQuery = {}, options) {
  const entities = [];
  let page = 1;
  let hasMore = true;

  while (hasMore) {
    const query = { ...baseQuery, page, pageSize: MAP_PAGE_SIZE };
    const response = options
      ? await listEntities(query, options)
      : await listEntities(query);
    entities.push(...(response.data || []));
    hasMore = Boolean(response.hasMore);
    page += 1;
  }

  return entities;
}
